import axios from './axios';

export function updateNotificationPreferences(payload: any) {
  return axios.patch(`/company_users/notification_preferences/`, payload).then(({ data }) => data);
}
